export default function () {
  return (
    <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none'}}>
      <div style={{position: 'fixed', bottom: 40, left: 40}}>hello@happyducktyping.com</div>
    </div>
  )
}
